<template>
  <el-table-column
    prop="currency.name"
    label="Deviza"
    show-overflow-tooltip
    min-width="100"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.currency_name }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'currency.name',
  };
</script>
